import { SceneWrapper } from '~/components';
import { FormikProps, isEmpty, useFormikContext } from '~/modules';
import { integerToCurrencyWithoutCents } from '~/utils';
import { CreditSimulationValueFormValues } from './schema';
import { ButtonComponent, Input } from './styles';

type CreditSimulationValueProps = {
  loading: boolean;
};

const CreditSimulationValue = ({ loading }: CreditSimulationValueProps) => {
  const {
    values,
    errors,
    setFieldValue,
    submitForm,
    isValid,
  }: FormikProps<CreditSimulationValueFormValues> = useFormikContext();

  const handleChange = ({ target }) => {
    const numericValue = target.value.replace(/\D/g, '');
    if (!numericValue) {
      setFieldValue('creditSimulationValue', '');
      return;
    }

    const formattedValue = integerToCurrencyWithoutCents(Number(numericValue));
    setFieldValue('creditSimulationValue', formattedValue);
  };

  return (
    <SceneWrapper
      footer={
        <ButtonComponent
          id="btn-simulation-value"
          onPress={submitForm}
          disabled={!isValid || isEmpty(values.creditSimulationValue)}
          onLoading={loading}
          fullWidth
        >
          SIMULAR
        </ButtonComponent>
      }
    >
      <Input
        placeholder="R$"
        name="creditSimulationValue"
        id="creditSimulationValue"
        value={values.creditSimulationValue}
        onChange={handleChange}
        label="Qual o valor desejado?"
        errors={errors?.creditSimulationValue}
        inputMode="numeric"
        inputProps={{ inputMode: 'numeric' }}
        autoFocus
      />
    </SceneWrapper>
  );
};

export default CreditSimulationValue;
